import actions from '../../actionTypes';

export default siteId => {
  return {
    type: actions.GET_RP_DETAIL,
    siteId
  };
};



// WEBPACK FOOTER //
// ./src/reducers/status/actions/getRpDetail.js